// @flow
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import { withStyles } from "@material-ui/core/styles";
import type { UserProfile } from '../../typeDefinitions/userProfile';

type Classes = {
    avatars: string,
}

type ProvidedProps = {
    classes: Classes,
}

type Props = {
    user: UserProfile,
    label?: string,
}

const styles = (theme) => ({
    avatars: {
        backgroundColor: theme.palette.primary.main,
    }
});

const UserProfileField = (props: Props & ProvidedProps) => {
    const avatar = (): string => {
        const { firstName, lastName, userName} = props.user;
        if (firstName)
            return firstName.charAt(0);
        if (lastName)
            return lastName.charAt(0);

        return userName.charAt(0);
    };

    return (
        <React.Fragment>
            <Typography variant="body1">
                {props.label}
            </Typography>
            {
                props.user &&
                <Grid container spacing={1} alignItems="center">
                    <Grid item>
                        <Avatar className={props.classes.avatars}>
                            {avatar()}
                        </Avatar>
                    </Grid>
                    <Grid item>
                        <Typography variant="subtitle1">
                            {props.user.firstName} {props.user.lastName}
                        </Typography>
                        <Typography variant="caption">
                            {props.user.userName}
                        </Typography>
                    </Grid>
                </Grid>
            }
        </React.Fragment>
    );
}
 
export default withStyles(styles)(UserProfileField);
